/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MediaListRenderer_media = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly id: string;
            readonly public_at: unknown | null;
            readonly title: string | null;
            readonly thumbnails: {
                readonly small: string | null;
            } | null;
            readonly __typename: string;
        } | null;
    } | null> | null;
    readonly " $refType": "MediaListRenderer_media";
};
export type MediaListRenderer_media$data = MediaListRenderer_media;
export type MediaListRenderer_media$key = {
    readonly " $data"?: MediaListRenderer_media$data;
    readonly " $fragmentRefs": FragmentRefs<"MediaListRenderer_media">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaListRenderer_media",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SlugableEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "public_at",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Thumbnail",
              "kind": "LinkedField",
              "name": "thumbnails",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "small",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SlugableConnection",
  "abstractKey": null
};
(node as any).hash = 'e1d87be0888d8edec05cde2dd2525ac9';
export default node;
